module.exports = __webpack_public_path__ + "h5/img/bs_17.c884e834.jpg";